import { z } from 'zod';

/* Governança de contas no backoffice (ADR-0730). @username reservados: mesma regra de formato do
   handle público (auth-service `^[a-z0-9_]{3,30}$`). Reservar um handle que não é sequer válido
   como username não faz sentido — por isso o body exige o formato canônico. */
export const RESERVED_USERNAME_RE = /^[a-z0-9_]{3,30}$/;
const MAX_RESERVED_USERNAMES = 500;

export const reservedUsernamesResponseDto = z.object({ usernames: z.array(z.string()) });
export type ReservedUsernamesResponse = z.infer<typeof reservedUsernamesResponseDto>;

/* Substitui a lista inteira (RMW no config-service). Cada handle validado + o service normaliza
   (lowercase) e deduplica antes de persistir. */
export const updateReservedUsernamesBody = z.object({
  usernames: z
    .array(z.string().min(3).max(30).regex(RESERVED_USERNAME_RE))
    .max(MAX_RESERVED_USERNAMES),
});
export type UpdateReservedUsernamesBody = z.infer<typeof updateReservedUsernamesBody>;
